// eslint-disable-next-line no-shadow
export enum Languages {
  // eslint-disable-next-line no-unused-vars
  PT = "pt-BR",
  // eslint-disable-next-line no-unused-vars
  EN = "en-US",
}
